import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, Matches, MaxLength } from "class-validator";
import { SaleDetailsDto } from "./asset-details.dto";

export class AssetsSaleDto {

    @ApiProperty()
    assetSaleId: number;
    
    @ApiProperty()
    saleDetails : SaleDetailsDto[];

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    createdUser: string;

    @ApiProperty()
    updatedAt : Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, {message: 'Updated User allows maximum 40 characters'})
    @Matches(new RegExp('"^(?:[a-zA-Z\\s]|)+$"'), {message: 'Updated User should be only alphabets'})
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

}